import mapboxgl from "mapbox-gl";
import {plainToClass, Type} from "class-transformer";
// import store from "../../plan_trail/store/store";
import {generateID} from "../helpers/IDGenerator"
import {singleHiikerElevation} from "../helpers/HiikerElevationApiHelper";
import {LineStringFeature, LineStringGeometry} from "./LineStringFeature";

export async function setElevationData(any) {
  let hiikerElevation = await singleHiikerElevation(any.markerGeometry.coordinates[1], any.markerGeometry.coordinates[0])
  if (hiikerElevation != null) {
    any.markerProperties.ele = typeof hiikerElevation.elevation === 'string' 
      ? parseInt(hiikerElevation.elevation) 
      : hiikerElevation.elevation
    any.markerGeometry.coordinates = [hiikerElevation.lng, hiikerElevation.lat, hiikerElevation.elevation]
  }
}

export class MarkerFeature {
  type: string = "Feature";
  markerGeometry: MarkerGeometry;
  markerProperties: MarkerProperties;

  constructor (markerGeometry: MarkerGeometry, markerProperties: MarkerProperties) {
    this.markerGeometry = markerGeometry;
    this.markerProperties = markerProperties;
  }

  static async fromCoordinates(coordinates: number[], skipElevation = false): Promise<MarkerFeature> {
    let markerFeature = new MarkerFeature(
      new MarkerGeometry(coordinates),
      new MarkerProperties(generateID(), true, Date.now().toString(), 0)
    );
    if (!skipElevation) {
      await markerFeature.setElevationData()
    }
    return markerFeature;
  }

  static fromGeoJson(geoJson: any) {
    return new MarkerFeature(
      new MarkerGeometry(geoJson.geometry.coordinates),
      new MarkerProperties(`${generateID()}`, geoJson.properties.snap, geoJson.properties.date, geoJson.properties.elevation_meters)
    );
  }


  async setElevationData() {
    await setElevationData(this)
  }

  toGeoJSONSourceRaw() {
    return {
      type: "geojson" as const,
      data: this.toGeoJson(),
    };
  }

  toGeoJson() {
    return {
      type: "Feature",
      geometry: plainToClass(MarkerGeometry, this.markerGeometry).toJson(),
      properties: plainToClass(MarkerProperties, this.markerProperties).toJson(),
    };
  }

  toGeoJsonString(): string {
    return JSON.stringify(this.toGeoJson());
  }
}

export class MarkerGeometry {
  type: string = "Point";
  coordinates: number[] = [];

  lat(): number {
    return this.coordinates[1]
  }

  lon(): number {
    return this.coordinates[0]
  }

  constructor (coordinates: number[]) {
    this.coordinates = coordinates
  }

  toJson() {
    return {
      type: "Point",
      coordinates: this.coordinates,
    };
  }
}

export class MarkerProperties {
  id: string;
  isSnap: boolean;
  date: string;
  ele: number;
  lineStringFeatures: LineStringFeature[] = []

  constructor (id: string, isSnap: boolean, date: string, ele: number) {
    this.id = id;
    this.isSnap = isSnap;
    this.date = date;
    this.ele = ele;
  }

  toJson() {
    return {
      id: this.id,
      isSnap: this.isSnap,
      date: this.date,
      ele: this.ele,
    };
  }
}
